import { render, staticRenderFns } from "./DialogAddBookToBank.vue?vue&type=template&id=3ed4ff8e"
import script from "./DialogAddBookToBank.vue?vue&type=script&lang=js"
export * from "./DialogAddBookToBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed4ff8e')) {
      api.createRecord('3ed4ff8e', component.options)
    } else {
      api.reload('3ed4ff8e', component.options)
    }
    module.hot.accept("./DialogAddBookToBank.vue?vue&type=template&id=3ed4ff8e", function () {
      api.rerender('3ed4ff8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddBookToBank.vue"
export default component.exports